import get from 'lodash/get';
import EmailCaptureFormComponent from './email-capture-form.component';

export default class EmailCaptureCheckEmailFormComponent extends EmailCaptureFormComponent {
    onError(error) {
        // check if it is 404 error - show that user doesn't exist
        // otherwise - call error callback
        const responseStatus = get(error, 'response.status');
        if (responseStatus === 404) {
            this.showErrorsSummaryFromArray(['User is not found. Please enter your details on the previous step']);
            return;
        }

        this._onErrorCallback(error);
    }
}
